import apiClient from "./client";
import {
  ICategory,
  ICategoryTag,
  CreateCategoryDto,
  UpdateCategoryDto,
  CreateCategoryTagDto,
  UpdateCategoryTagDto,
  CategoryStatus
} from "shared";

// Categories API
export const categoriesApi = {
  async getAll(): Promise<ICategory[]> {
    const { data } = await apiClient.get<ICategory[]>("/categories");
    return data;
  },

  async getById(id: string): Promise<ICategory> {
    const { data } = await apiClient.get<ICategory>(`/categories/${id}`);
    return data;
  },

  async create(category: CreateCategoryDto): Promise<ICategory> {
    const { data } = await apiClient.post<ICategory>("/categories", category);
    return data;
  },

  async update(id: string, category: UpdateCategoryDto): Promise<ICategory> {
    const { data } = await apiClient.put<ICategory>(`/categories/${id}`, category);
    return data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/categories/${id}`);
  },

  async updateStatus(id: string, status: CategoryStatus): Promise<ICategory> {
    const { data } = await apiClient.patch<ICategory>(`/categories/${id}/status`, { status });
    return data;
  }
};

// Category Tags API
export const categoryTagsApi = {
  async getAll(): Promise<ICategoryTag[]> {
    const { data } = await apiClient.get<ICategoryTag[]>("/category-tags");
    return data;
  },

  async create(tag: CreateCategoryTagDto): Promise<ICategoryTag> {
    const { data } = await apiClient.post<ICategoryTag>("/category-tags", tag);
    return data;
  },

  async update(id: string, tag: UpdateCategoryTagDto): Promise<ICategoryTag> {
    const { data } = await apiClient.put<ICategoryTag>(`/category-tags/${id}`, tag);
    return data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/category-tags/${id}`);
  }
};